// extracted by mini-css-extract-plugin
export default {"wrapper":"Diamond_wrapper__8zaBi","tabs":"Diamond_tabs__IFi4y","center":"Diamond_center__vmg6c"};